var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.9,9.9 L1.8,9.9 L1.8,11.7 L1.8,16.2 C1.8,17.1927 2.6073,18 3.6,18 L6.3,18 L11.7,18 L14.4,18 C15.3927,18 16.2,17.1927 16.2,16.2 L16.2,11.7 L16.2,9.9 L17.1,9.9 C17.4636,9.9 17.793,9.6804 17.9316,9.3447 C18.0711,9.0081 17.9937,8.6211 17.7363,8.3637 L9.6363,0.2637 C9.2844,-0.0882 8.7156,-0.0882 8.3637,0.2637 L0.2637,8.3637 C0.0063,8.6211 -0.0711,9.0081 0.0684,9.3447 C0.207,9.6804 0.5364,9.9 0.9,9.9 Z M7.2,16.2 L7.2,11.7 L10.8,11.7 L10.8,16.2 L7.2,16.2 Z M9,2.1726 L14.4,7.5726 L14.4,11.7 L14.4,11.7 L14.4009,16.2 L12.6,16.2 L12.6,11.7 C12.6,10.7073 11.7927,9.9 10.8,9.9 L7.2,9.9 C6.2073,9.9 5.4,10.7073 5.4,11.7 L5.4,16.2 L3.6,16.2 L3.6,11.7 L3.6,9 L3.6,7.5726 L9,2.1726 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-32.000000, -105.000000)",
    fill: "#F6931E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Item-1",
    transform: "translate(15.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bx-home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    xlinkHref: "#path-1"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.9548766fb4a119d9d54a3a0ce0d30024.svg";
export { ForwardRef as ReactComponent };